import { render, staticRenderFns } from "./CreateAddressBook.vue?vue&type=template&id=dc06fdf2&scoped=true&"
import script from "./CreateAddressBook.vue?vue&type=script&lang=js&"
export * from "./CreateAddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06fdf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VContainer,VDatePicker,VDialog,VForm,VMenu,VProgressLinear,VRow,VSelect,VSpacer,VTextField,VTextarea})
